
import {
  UsersIcon,
  BoltIcon,
  ClockIcon,
} from '@heroicons/react/24/solid';

import {
  ClockIcon as ClockOutlineIcon,
} from '@heroicons/react/24/outline';

import type {
  KPIItem,
} from '../types/kpi.types';

import type {
  KpiTrendResponse,
} from '../types/kpiTrend.types';

/**
 * MOCK RESPONSE DATA
 */
export const kpiMockData: KpiTrendResponse = {
  totalAssociates: 150,

  risk_Associates: 12,
  previous_Risk_Associates: 15,

  avg_Productivity_Percent: 87.5,
  previous_Productivity_Percent: 84.2,
  productivity_Raise_Dip: 3.3,

  avg_ActiveHours: 8.1,
  previous_ActiveHours: 7.6,
  activeHours_Raise_Dip: 0.5,

  avg_Idle_Percentage: 11.8,
  previous_Idle_Percentage: 13.2,
  idle_Raise_Dip: -1.4,

  attendance_Percentage: 94.5,
  previous_Attendance_Percentage: 93.1,
  attendance_Raise_Dip: 1.4,
};

export const mapKpiCards = (
  data: KpiTrendResponse,
): KPIItem[] => [
  {
    title: 'Span of Control',
    value: data.totalAssociates.toString(),
    subtitle: 'associates',
    footer: `${data.attendance_Percentage}% attendance`,
    icon: UsersIcon,
    iconBg: 'bg-[#4F9CF9]',
    footerColor: 'text-[#78716C]',
    hoverBg: 'hover:bg-[#F0F7FF]',
    borderColor: 'hover:border-[#93C5FD]',
    route: '/team-active-hours',
  },
  {
    title: 'Avg. Productivity',
    value: data.avg_Productivity_Percent.toFixed(1),
    subtitle: '%',
    footer: `${
      data.productivity_Raise_Dip >= 0 ? '▲' : '▼'
    } ${Math.abs(data.productivity_Raise_Dip).toFixed(1)} pts vs last wk`,
    icon: BoltIcon,
    iconBg: 'bg-[#36C690]',
    hoverBg: 'hover:bg-[#F2FFF8]',
    borderColor: 'hover:border-[#86EFAC]',
    footerColor:
      data.productivity_Raise_Dip >= 0
        ? 'text-[#0F9F6E]'
        : 'text-[#EF4444]',
    route: '/rm-productivity-report',
  },
  {
    title: 'Avg. Active Hours',
    value: data.avg_ActiveHours.toFixed(1),
    subtitle: 'hrs/day',
    footer: `${
      data.activeHours_Raise_Dip >= 0 ? '▲' : '▼'
    } ${Math.abs(data.activeHours_Raise_Dip).toFixed(1)} hrs vs last wk`,
    icon: ClockIcon,
    iconBg: 'bg-[#8B5CF6]',
    hoverBg: 'hover:bg-[#FAF5FF]',
    borderColor: 'hover:border-[#C4B5FD]',
    footerColor:
      data.activeHours_Raise_Dip >= 0
        ? 'text-[#0F9F6E]'
        : 'text-[#EF4444]',
  },
  {
    title: 'Span idle %',
    value: data.avg_Idle_Percentage.toFixed(1),
    subtitle: '%',
    footer: `${
      data.idle_Raise_Dip <= 0 ? '▼' : '▲'
    } ${Math.abs(data.idle_Raise_Dip).toFixed(1)} pts · target ≤14%`,
    icon: ClockOutlineIcon,
    iconBg: 'bg-[#F97316]',
    hoverBg: 'hover:bg-[#FFF7ED]',
    borderColor: 'hover:border-[#FDBA74]',
    footerColor:
      data.idle_Raise_Dip <= 0
        ? 'text-[#0F9F6E]'
        : 'text-[#EF4444]',
    route: '/idle-time-report',
  },
];
